import _uniqueId from 'lodash/uniqueId';
import React, { Component, PropTypes } from 'react';
import ComponentTitle from '../shared/ComponentTitle';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

/**
 * Class representing the interactive weather radar for the current location.
 */
class WeatherRadar extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    title: PropTypes.string,
    allowFullScreen: PropTypes.bool,
    titleType: PropTypes.string
  }

  static defaultProps = {
    title: null,
    allowFullScreen: false,
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  state = {
    allowRadarInteraction: false
  }

  componentDidMount() {
    const $ = window['$'];

    this._mountId = _uniqueId('WeatherRadar');

    $(window).on('scroll.' + this._mountId, this._addRadarCover.bind(this));
  }

  componentWillUnmount() {
    const $ = window['$'];

    $(window).off('.' + this._mountId);
  }

  _removeRadarCover() {
    this.setState({
      allowRadarInteraction: true
    });
  }

  _addRadarCover() {
    this.setState({
      allowRadarInteraction: false
    });
  }

  render() {
    const { src, title, allowFullScreen, titleType } = this.props;
    const { allowRadarInteraction } = this.state;

    return (
      <div className="WeatherRadar">
        <ComponentTitle titleType={titleType} title={title} classes="WeatherRadar-header" />
        <div className="WeatherRadar-container" onMouseLeave={this._addRadarCover.bind(this)}>
          <iframe
            src={src}
            height="315"
            width="560"
            allowFullScreen={allowFullScreen}
            frameBorder="0"
            />
          <div
            className={'WeatherRadar-clickCover' + (allowRadarInteraction ? ' removeCover' : '')}
            onClick={() => this._removeRadarCover()}
            />
        </div>
      </div>
    );
  }

}

export default WeatherRadar;



// WEBPACK FOOTER //
// ./app/components/weather/WeatherRadar.js